import { useEffect, useRef, useState } from 'react';
export function useFloatingMenuHeight() {
    const floatingMenuRef = useRef(null);
    const [floatingMenuHeight, setFloatingMenuHeight] = useState(0);
    useEffect(function updateFloatingMenuHeight() {
        if (!floatingMenuRef.current)
            return;
        setFloatingMenuHeight(floatingMenuRef.current.offsetHeight);
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setFloatingMenuHeight(entry.contentRect.height);
            }
        });
        observer.observe(floatingMenuRef.current);
        return () => observer.disconnect();
    }, []);
    return { floatingMenuRef, floatingMenuHeight };
}
